import { getCountryData } from './guaranteesMap';

const $ = jQuery;
const $taxonomies = $('.guarantees .js-cases-map--taxonomy');

export function guarantees() {
    // Only run if guarantees block is present
    if (!document.querySelector('section.guarantees')) {
        return;
    }
    
    if ($taxonomies.length === 0) {
        return;
    }

    // Taxonomy trigger
    $taxonomies.find('.cases-map__taxonomy-trigger').on('click', function () {
        const $this = $(this);
        const $parent = $this.closest('.cases-map__taxonomy');
        const $list = $parent.find('.cases-map__taxonomy-list');

        $taxonomies.not($parent).find('.cases-map__taxonomy-list').slideUp();
        $taxonomies.not($parent).removeClass('active');

        $list.slideToggle();
        $parent.toggleClass('active');
    });

    // Taxonomy trigger accordion
    $taxonomies.find('.cases-map__taxonomy-trigger-accordion').on('click', function () {
        const $this = $(this);
        const $wrap = $this.closest('.cases-map__taxonomy-sublist-wrap');
        const $siblings = $this.siblings('.cases-map__taxonomy-sublist');

        $siblings.slideToggle();
        $wrap.toggleClass('active');
    });

    // Click outside taxonomy trigger
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.guarantees .cases-map__taxonomy').length) {
            $taxonomies.removeClass('active');
            $taxonomies.find('.cases-map__taxonomy-list').slideUp();
        }
    });

    // Taxonomy item change
    $taxonomies.find('.cases-map__taxonomy-item input').on('change', function () {
        const searchValue = $('.guarantees .js-cases-map--search').val();
        let guarantees = [];
        
        // Check if casesData exists and has guarantee data
        if (typeof casesData !== 'undefined' && casesData.guarantee) {
            guarantees = casesData.guarantee;
        }
        
        guarantees = guarantees.filter((item) => {
            return item.title.toLowerCase().includes(searchValue.toLowerCase());
        });

        const filteredGuarantees = getGuaranteesFromActiveTaxonomies(guarantees);
        handleGuaranteeVisibility(filteredGuarantees);

        // check do we have any input checked
        checkIsAnyFilterApplied();
    });

    // Meta search filters
    $('.guarantees .js-cases-map--meta-search-filters').on('click', function () {
        const $this = $(this);
        const $wrapper = $('.guarantees .js-cases-map--taxonomies-wrapper');

        $wrapper.slideToggle();
        $this.toggleClass('active');
        $wrapper.toggleClass('active');
        handleMobileTaxonomyWrapper();
    });

    // Meta view change
    $('.guarantees .js-cases-map--meta-view').on('click', function () {
        checkIsAnyFilterApplied();
        const $this = $(this);
        const type = $this.data('view');

        if (type === 'list') {
            $('.guarantees .js-cases-map--container').hide();
            $('.guarantees .js-cases-map--posts-container').show();
        } else {
            $('.guarantees .js-cases-map--container').show();
            $('.guarantees .js-cases-map--posts-container').hide();
        }

        $this.addClass('active');
        $this.siblings().removeClass('active');
    });

    // Handle search
    $('.guarantees .js-cases-map--search').on('keyup', function () {
        const $this = $(this);
        const value = $this.val();
        let guarantees = [];
        
        // Check if casesData exists and has guarantee data
        if (typeof casesData !== 'undefined' && casesData.guarantee) {
            guarantees = casesData.guarantee;
        }
        
        guarantees = getGuaranteesFromActiveTaxonomies(guarantees);
        const filteredGuarantees = guarantees.filter((item) => {
            const searchValue = value.toLowerCase();
            const titleMatch = item.title.toLowerCase().includes(searchValue);
            return titleMatch;
        });

        checkIsAnyFilterApplied();
        handleGuaranteeVisibility(filteredGuarantees);
    });

    // Clear filters
    $('.guarantees .js-cases-map--clear-filters').on('click', function () {
        clearTaxonomies();
        $('.guarantees .js-cases-map--search').val('');
        let guarantees = [];
        
        // Check if casesData exists and has guarantee data
        if (typeof casesData !== 'undefined' && casesData.guarantee) {
            guarantees = casesData.guarantee;
        }
        
        handleGuaranteeVisibility(guarantees);
        checkIsAnyFilterApplied();
    });

    // Reset filters
    $('.guarantees .js-cases-map--reset').on('click', function () {
        clearTaxonomies();
        $('.guarantees .js-cases-map--search').val('');
        let guarantees = [];
        
        // Check if casesData exists and has guarantee data
        if (typeof casesData !== 'undefined' && casesData.guarantee) {
            guarantees = casesData.guarantee;
        }
        
        handleGuaranteeVisibility(guarantees);
        checkIsAnyFilterApplied();
    });

    $('.guarantees .js-cases-map--apply').on('click', function () {
        const $wrapper = $('.guarantees .js-cases-map--taxonomies-wrapper-mobile');
        $wrapper.removeClass('active');
        $wrapper.hide();
    });

    
}

function handleGuaranteeVisibility(guarantees) {
    const ids = getIdsFromGuarantees(guarantees);
    let countries = [];
    guarantees.forEach((item) => {
        if (item.countries) {
            item.countries.forEach((country) => {
                if (!countries.includes(country)) {
                    countries.push(country);
                }
            });
        }
    });

    $('.guarantees .js-case-map--card, .guarantees .card-post').each(function () {
        const $this = $(this);
        const id = $this.data('post-id');
        if (!ids.includes(id)) {
            $this.hide();
        } else {
            $this.show();
        }
    });

    if (guarantees.length === 0) {
        $('.guarantees .cases-map__no-results').removeClass('disabled');
    } else {
        $('.guarantees .cases-map__no-results').addClass('disabled');
    }

    getCountryData(countries);
}

function getIdsFromGuarantees(guarantees) {
    return guarantees.map((item) => item.id);
}

function getTaxonomies() {
    const taxonomies = {};
    $taxonomies.each(function () {
        const $this = $(this);
        const taxonomy = $this.data('taxonomy');
        const checkedInputs = $this.find('input:checked');
        const values = [];

        checkedInputs.each(function () {
            values.push($(this).val());
        });

        if (values.length > 0) {
            taxonomies[taxonomy] = values;
        }
    });

    return taxonomies;
}

function getGuaranteesFromActiveTaxonomies(guarantees) {
    const activeTaxonomies = getTaxonomies();
    
    if (Object.keys(activeTaxonomies).length === 0) {
        return guarantees;
    }

    return guarantees.filter((guarantee) => {
        return Object.keys(activeTaxonomies).every((taxonomyKey) => {
            const activeTerms = activeTaxonomies[taxonomyKey];
            const guaranteeTerms = guarantee.taxonomies[taxonomyKey] || [];
            
            if (activeTerms.length === 0) return true;
            
            return activeTerms.some((activeTerm) => {
                return guaranteeTerms.some((guaranteeTerm) => {
                    return guaranteeTerm.term_id == activeTerm;
                });
            });
        });
    });
}

function clearTaxonomies() {
    $taxonomies.find('input:checked').prop('checked', false);
    $('.guarantees .js-cases-map--clear-filters').addClass('hidden');
}

function handleMobileTaxonomyWrapper() {
    const $wrapper = $('.guarantees .js-cases-map--taxonomies-wrapper-mobile');
    if (window.innerWidth <= 1024) {
        $wrapper.addClass('active');
        $wrapper.show();
    }
}

function checkIsAnyFilterApplied() {
    const hasCheckedInputs = $taxonomies.find('input:checked').length > 0;
    const hasSearchValue = $('.guarantees .js-cases-map--search').val().length > 0;

    if (hasCheckedInputs || hasSearchValue) {
        $('.guarantees .js-cases-map--clear-filters').removeClass('hidden');
    } else {
        $('.guarantees .js-cases-map--clear-filters').addClass('hidden');
    }
}

function loadMoreGuarantees() {
    const $loadMoreBtn = $('.guarantees .js-guarantee--load-more');
    const $postsContainer = $('.guarantees .js-cases-map--posts-container .cases-archive__posts');
    
    // Get current posts count
    const currentPostsCount = $postsContainer.find('.card-post').length;
    
    // Get all guarantees data
    let guarantees = [];
    if (typeof casesData !== 'undefined' && casesData.guarantee) {
        guarantees = casesData.guarantee;
    }
    
    // Show next batch of posts (6 more)
    const nextBatch = guarantees.slice(currentPostsCount, currentPostsCount + 6);
    
    if (nextBatch.length > 0) {
        // Create HTML for new posts
        nextBatch.forEach(guarantee => {
            // Create CTAs HTML
            let ctasHtml = '';
            if (guarantee.taxonomies) {
                Object.values(guarantee.taxonomies).flat().forEach(term => {
                    ctasHtml += `<span class="card-post__cta">${term.name}</span>`;
                });
            }
            
            const postHtml = `
                <a href="#" class="card-post color-light" data-post-id="${guarantee.id}">
                    <div class="card-post__container">
                        <div class="card-post__ctas color-primary">
                            ${ctasHtml}
                        </div>
                        <div class="card-post__content">
                            <div class="card-post__gradient"></div>
                            <p class="mb-2 font-regular p-large">${guarantee.title}</p>
                            <div class="mt-4">
                                <span class="c-button c-button--primary">
                                    <span>Read more</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            `;
            $postsContainer.append(postHtml);
        });
        
        // Hide load more button if no more posts
        if (currentPostsCount + nextBatch.length >= guarantees.length) {
            $loadMoreBtn.hide();
        }
    } else {
        $loadMoreBtn.hide();
    }
}
